export const distanceUnits = {
  cm: 'cm',
  in: 'in',
  ft: 'ft',
  m: 'm',
  yd: 'yd',
  mi: 'mi',
  km: 'km',
}

// legacy benchmarks have distance units in imperial/metric format
export const legacyDistances = {
  'in/cm': true,
  'ft/m': true,
  'mi/km': true,
}

export const allUnits = {
  'lb/kg': 'lb/kg',
  ...distanceUnits,
  reps: 'reps',
  time: 'time',
}

export const allSystemUnits = {
  lb: 'lb',
  kg: 'kg',
  ...distanceUnits,
  reps: 'reps',
  time: 'time',
}

export const systemUnitToFullUnit = {
  lb: 'lb/kg',
  kg: 'lb/kg',
  ...distanceUnits,
  reps: 'reps',
  time: 'time',
}

export const fullUnitGroups = {
  weight: [allUnits['lb/kg']],
  distance: Object.values(distanceUnits),
  reps: [allUnits.reps],
  time: [allUnits.time],
}

export const systemUnitGroups = {
  weight: [allSystemUnits.lb, allSystemUnits.kg],
  distance: Object.values(distanceUnits),
  reps: [allSystemUnits.reps],
  time: [allSystemUnits.time],
}

export const textMatchToUnit = {
  r: allSystemUnits.reps,
  re: allSystemUnits.reps,
  rep: allSystemUnits.reps,
  reps: allSystemUnits.reps,
  repetition: allSystemUnits.reps,
  repetitions: allSystemUnits.reps,
  time: allSystemUnits.reps,
  times: allSystemUnits.reps,
  lb: allSystemUnits.lb,
  lbs: allSystemUnits.lb,
  pound: allSystemUnits.lb,
  pounds: allSystemUnits.lb,
  kg: allSystemUnits.kg,
  kgs: allSystemUnits.kg,
  kilogram: allSystemUnits.kg,
  kilograms: allSystemUnits.kg,
  in: allSystemUnits.in,
  inch: allSystemUnits.in,
  inches: allSystemUnits.in,
  cm: allSystemUnits.cm,
  centimeter: allSystemUnits.cm,
  centimeters: allSystemUnits.cm,
  centimetre: allSystemUnits.cm,
  centimetres: allSystemUnits.cm,
  ft: allSystemUnits.ft,
  feet: allSystemUnits.ft,
  m: allSystemUnits.m,
  meter: allSystemUnits.m,
  meters: allSystemUnits.m,
  metre: allSystemUnits.m,
  metres: allSystemUnits.m,
  yd: allSystemUnits.yd,
  yard: allSystemUnits.yd,
  yards: allSystemUnits.yd,
  mi: allSystemUnits.mi,
  mile: allSystemUnits.mi,
  miles: allSystemUnits.mi,
  km: allSystemUnits.km,
  kilometer: allSystemUnits.km,
  kilometers: allSystemUnits.km,
  kilometre: allSystemUnits.km,
  kilometres: allSystemUnits.km,
}

export const timeTextMatchToUnit = {
  hr: 'hr',
  hrs: 'hr',
  hour: 'hr',
  hours: 'hr',
  min: 'min',
  mins: 'min',
  minute: 'min',
  minutes: 'min',
  sec: 'sec',
  secs: 'sec',
  second: 'sec',
  seconds: 'sec',
  s: 'sec',
}
